import React, { useState, useEffect } from 'react';
import DocPageHeader from 'components/docs/DocPageHeader';
import CustomerCharts from './CustomerCharts'; 
import { Col } from 'react-bootstrap';
import ConnectorManagementPanel from './ConnectorManagementPanel';
import useConnectorGroup from 'hooks/useConnectorGroup';
import KpiStats from 'shiplab-components/ConnectorKpiStatus';
import { useLoading } from 'providers/LoadingProvider'; 


const ConnectorGroupConnectorManagementPage: React.FC = () => {
  const [connectorGroupId, setConnectorGroupId] = useState<number>(() => {
    const params = new URLSearchParams(window.location.search);
    const connectorGroupIdParam = params.get('id');
    return connectorGroupIdParam ? Number(connectorGroupIdParam) : 0;
  });

  const { showLoading, hideLoading } = useLoading();
  
  useEffect(() => {
    showLoading(); 
    const timeout = setTimeout(() => {
      hideLoading(); 
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  const [connectorGroupName, setConnectorGroupName] = useState<string>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("name") || 'Unknown Group';
  });
// لطفا اینها پاک نشن که اگه دوباره اینها رو تو کد خواستید سریع برگردونیم
  // const [packageAvg, setPackageAvg] = useState<string>('0');
  // const [invoiceAvg, setInvoiceAvg] = useState<string>('0');
  // const [netSpentAvg, setNetSpentAvg] = useState<string>('0');

  const { 
    connectorGroup, connectors, monthlySummary, weeklySummary, createConnector, updateConnector, deleteConnector, calculateMonthlyAverage, accessToken, loading, error 
  } = useConnectorGroup(connectorGroupId);

  useEffect(() => {
    showLoading(); //  نمایش لودینگ 

    // const fetchAverages = async () => {
    //   setPackageAvg(await calculateMonthlyAverage(connectorGroupId, accessToken, 'package_count'));
    //   setInvoiceAvg(await calculateMonthlyAverage(connectorGroupId, accessToken, 'invoice_count'));
    //   setNetSpentAvg(await calculateMonthlyAverage(connectorGroupId, accessToken, 'net_spent'));
 
    // };

    // fetchAverages();

    const timeout = setTimeout(() => {
      hideLoading(); // 
    }, 1000);
    console.log("🛑 Cleanup function: Clearing timeout");

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div>
      <DocPageHeader title={`${connectorGroupName}`} />
      <p>Add and manage your carrier connectors here to enable automatic collection of your carrier invoice data.</p>
      <ConnectorManagementPanel
        connectorGroupId={connectorGroupId}
        connectors={connectors}
        createConnector={createConnector}
        updateConnector={updateConnector}
        deleteConnector={deleteConnector}
      />
    </div>
  );
};

export default ConnectorGroupConnectorManagementPage;